import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";

import { Row, Col, FullRow } from "../../framework/Grid/";
import { Dialog, FlatButton } from "material-ui";
import { isNil, isEmpty, pull, sortBy, isUndefined } from "lodash";
import { Link } from "react-router-dom";
import Select from "react-select";

import CustomTagVariables from "./CustomTagVariables";
import HashedEmailVariables from "./HashedEmail";

const inputStyle = {
  border: "solid 1px #000",
  height: "28px",
  width: "100%",
  paddingLeft: "10px",
  fontSize: "13px",
  color: "black",
};

const styles = {
  tableHeaderStyle: {
    border: "none",
    background: "#E4E4E4",
  },
  arrowStyle: {
    position: "absolute",
    top: "0.4em",
  },
  tableHeaderColumn: {
    height: "30px",
    color: "black",
    cursor: "pointer",
    fontWeight: "bolder",
    paddingLeft: "10px",
    position: "relative",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  tableTd: {
    paddingLeft: "10px",
    height: "30px",
    borderBottom: "1px solid black",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  tableHeaderSortedColumn: {
    height: "30px",
    color: "black",
    cursor: "pointer",
    fontWeight: "bolder",
    position: "relative",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    paddingLeft: "10px",
    backgroundColor: "#CECECE",
    backgroundClip: "padding-box",
  },
  tableRowColumn: {
    position: "relative",
  },
  settingStyle: {
    position: "absolute",
    right: "6em",
    top: "0.9em",
    cursor: "pointer",
  },
};

class TagCreation extends AcquireWebComponent {
  componentWillMount() {
    this.state = {
      id: this.props.id ? this.props.id : undefined,
      isValidDomain: this.props.website_url ? true : false,
      showTagConfirmDialog: false,
      showImgTagDialog: false,
      clientName: "",
      buName: "",
      clientId: undefined,
      showCustomVarDialog: false,
      tag_variables: this.props.tag_variables ? this.props.tag_variables : [],
      origin_tag_variables: this.props.tag_variables
        ? this.props.tag_variables
        : [],
      pass_variables: this.props.pass_variables
        ? this.props.pass_variables
        : [],
      origin_pass_variables: this.props.pass_variables
        ? this.props.pass_variables
        : [],
      hash_format: this.props.hash_format ? this.props.hash_format : [],
      origin_hash_format: this.props.hash_format
        ? this.props.hashed_format
        : [],
      hash_case: this.props.hash_case ? this.props.hash_case : "upper",
      origin_hash_case: this.props.hash_case ? this.props.hash_case : "upper",
      tag_vars_error_message: undefined,
      tag_vars_deploy: this.props.tag_vars_deploy
        ? this.props.tag_vars_deploy
        : "unique",
      tag_type: this.props.tag_type ? this.props.tag_type : "Web",
      filter_tag_type: this.props.tag_type ? this.props.tag_type : "Web",
    };
  }

  handleCampaignNameChange(e, val) {
    e.preventDefault();
    this.props.setTagCampaignName(val);
  }

  handleWebsiteNameChange(e, val) {
    e.preventDefault();
    this.props.setTagWebsiteName(val);
  }

  handleWebsiteURLChange(e, val) {
    e.preventDefault();
    this.props.setTagWebsiteURL(val);
    //const isUrl = /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/i.test(val)
    const isUrl = /[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/i.test(
      val,
    );
    if (isUrl === true) this.setState({ isValidDomain: true });
    else this.setState({ isValidDomain: false });
  }

  handleTagDevTypeChanged(e) {
    this.setState({
      tag_type: e.value,
    });
  }

  showCustomVarsDialog() {
    const {
      tag_variables,
      pass_variables,
      hash_format,
      hash_case,
    } = this.state;
    this.setState({
      showCustomVarDialog: true,
      origin_tag_variables: tag_variables.slice(),
      origin_pass_variables: pass_variables.slice(),
      origin_hash_format: hash_format.slice(),
      origin_hash_case: hash_case.slice(),
    });
  }

  tagVarChanged(e, index) {
    const { tag_variables } = this.state;
    tag_variables[index] = e.target.value;
    this.setState({
      tag_variables: tag_variables,
      tag_vars_error_message: undefined,
    });
  }

  addTagVariable() {
    const v = this.state.tag_variables;
    if (v.length < 5) v.push("");
    this.setState({
      tag_variables: v,
      tag_vars_error_message: undefined,
    });
  }

  removeTagVariable() {
    const v = this.state.tag_variables;
    if (v.length > 0) v.pop();
    this.setState({
      tag_variables: v,
      tag_vars_error_message: undefined,
    });
  }

  addPassThrough() {
    const v = this.state.pass_variables;
    if (v.length < 5) v.push("");
    this.setState({
      pass_variables: v,
      tag_vars_error_message: undefined,
    });
  }

  removePassThrough() {
    const v = this.state.pass_variables;
    if (v.length > 0) v.pop();
    this.setState({
      pass_variables: v,
      tag_vars_error_message: undefined,
    });
  }

  passThroughChanged(e, index) {
    const { pass_variables } = this.state;
    pass_variables[index] = e.target.value;
    this.setState({
      pass_variables: pass_variables,
      tag_vars_error_message: undefined,
    });
  }

  cancelSaveCustomVars() {
    const {
      origin_tag_variables,
      origin_pass_variables,
      origin_hash_case,
      origin_hash_format,
    } = this.state;
    this.setState({
      tag_vars_error_message: undefined,
      tag_variables: origin_tag_variables.slice(),
      pass_variables: origin_pass_variables.slice(),
      hash_case: origin_hash_case.slice(),
      hash_format: origin_hash_format.slice(),
      showCustomVarDialog: false,
    });
  }

  handleHashFormatChanged(e) {
    const { hash_format } = this.state;
    if (e.target.checked === true) {
      hash_format.push(e.target.value);
    } else {
      pull(hash_format, e.target.value);
    }
    this.setState({ hash_format: sortBy(hash_format) });
  }

  handleHashCaseChanged(e) {
    this.setState({ hash_case: e.target.value });
  }

  saveCustomVars() {
    const { tag_variables, pass_variables } = this.state;
    const emptyTag = tag_variables.find((val) => {
      return isEmpty(val);
    });
    if (!isNil(emptyTag)) {
      this.setState({
        tag_vars_error_message: "Page reference name can not be empty!",
      });
      return;
    }
    const duplicateTag = tag_variables.filter(function (
      value,
      index,
      iteratee,
    ) {
      return iteratee.includes(value, index + 1);
    });
    if (!isEmpty(duplicateTag)) {
      this.setState({
        tag_vars_error_message:
          "Duplicated page reference names, Please check again",
      });
      return;
    }

    const emptyPass = pass_variables.find((val) => {
      return isEmpty(val);
    });
    if (!isNil(emptyPass)) {
      this.setState({
        tag_vars_error_message: "Pass through name can not be empty!",
      });
      return;
    }
    const duplicatePass = pass_variables.filter(function (
      value,
      index,
      iteratee,
    ) {
      return iteratee.includes(value, index + 1);
    });
    if (!isEmpty(duplicatePass)) {
      this.setState({
        tag_vars_error_message:
          "Duplicated pass through names, Please check again",
      });
      return;
    }
    this.setState({
      tag_vars_error_message: undefined,
      showCustomVarDialog: false,
    });
  }

  clickGenerateTag(evt) {
    evt.preventDefault();
    this.props.clearTagError();
    this.setState({ showTagConfirmDialog: true });
  }

  clickBack2TagList(e) {
    e.preventDefault();
    this.props.clearTagError();
  }

  handleCloseConfirmDialog(confirm) {
    if (confirm === true) {
      const {
        client_info,
        website_name,
        website_url,
        campaign_name,
      } = this.props;
      const {
        tag_variables,
        tag_vars_deploy,
        pass_variables,
        hash_format,
        hash_case,
      } = this.state;
      const data = {
        deploymentType: this.state.tag_type,
      };
      switch (this.state.tag_type) {
        case "Web":
          data["siteName"] = website_name;
          data["domain"] = website_url;
          if (!isEmpty(tag_variables)) {
            data["dynamic"] = tag_vars_deploy === "dynamic";
            data["tagParams"] = {
              pageReferences: tag_variables,
            };
          }
          break;
        case "Email":
          data["campaignName"] = campaign_name;
          break;
        default:
          return;
      }

      if (!isEmpty(pass_variables)) {
        if (isNil(data["tagParams"])) {
          data["tagParams"] = {
            passThroughs: pass_variables,
          };
        } else {
          data["tagParams"]["passThroughs"] = pass_variables;
        }
      }
      if (!isEmpty(hash_format)) {
        if (isNil(data["tagParams"])) {
          data["tagParams"] = {
            hashedEmails: hash_format,
            upperCase: hash_case === "upper",
          };
        } else {
          data["tagParams"]["hashedEmails"] = hash_format;
          data["tagParams"]["upperCase"] = hash_case === "upper";
        }
      }

      if (!isUndefined(this.props.id)) {
        data["id"] = this.props.id;
      }
      this.setState({ clientId: client_info.id });
      this.props.generateTag(client_info.id, data);
      this.props.getClientTags(client_info.id);
    } else {
      this.setState({ showTagConfirmDialog: false });
    }
  }

  handleOptionChange(e) {
    this.setState({
      tag_vars_deploy: e.target.value,
    });
  }

  back2ListClick(e) {
    e.preventDefault();
    this.props.clearTagError();
    this.props.history.push("/settings/tags/detail");
  }

  render() {
    const tagListPageUrl =
      this.props.location &&
      this.props.location.pathname.indexOf("settings") > 0
        ? "/settings/tags/list"
        : "/insights/tags/list";
    const { roleId } = this.props;
    const isSysAdmin = roleId === 1;
    const tagConfirmActions = [
      <FlatButton
        label="Cancel"
        primary={true}
        className="black-border btn-aa-info"
        backgroundColor={"#FFFFFF"}
        labelStyle={{ color: "#000" }}
        hoverColor={"#FFFFFF"}
        onClick={() => this.handleCloseConfirmDialog(false)}
      />,
      <FlatButton
        label="Confirm"
        primary={true}
        className="ml-20 mr-20 btn-aa-warning"
        backgroundColor={"red"}
        labelStyle={{ color: "white" }}
        hoverColor={"red"}
        onClick={() => this.handleCloseConfirmDialog(true)}
      />,
    ];

    const custVarsActions = [
      <span className="pull-left mt-10" style={{ color: "red" }}>
        {this.state.tag_vars_error_message}
      </span>,
      <button
        type="button"
        className="btn btn-default legitRipple btn-aa-default pull-right ml-10"
        onClick={(e) => {
          e.preventDefault();
          this.saveCustomVars();
        }}
      >
        Save
      </button>,
      <button
        type="button"
        className="btn btn-aa-info btn-default legitRipple btn-aa-secondary pull-right"
        style={{
          backgroundColor: "#FFF",
          color: "#000",
          border: "solid 1px #000",
        }}
        onClick={(e) => {
          e.preventDefault();
          this.cancelSaveCustomVars();
        }}
      >
        Cancel
      </button>,
    ];
    const showAddVarBtn =
      (isEmpty(this.state.tag_variables) ||
        isEmpty(this.state.tag_variables[0])) &&
      (isEmpty(this.state.pass_variables) ||
        isEmpty(this.state.pass_variables[0])) &&
      isEmpty(this.state.hash_format);

    const { tagDevOptions, clientName, buName } = this.props;
    return (
      <div
        style={this.props.style ? this.props.style : { padding: "20px 30%" }}
        key="tag-creation-container"
      >
        <div>
          <Link to={tagListPageUrl}>Tags</Link>
          &nbsp;&nbsp;&nbsp;>&nbsp;&nbsp;&nbsp;Insights Tag Creation
        </div>
        <div
          className="black-border no-padding mt-20 "
          style={{ background: "#FFF", fontWeight: 300 }}
        >
          <FullRow style={{ fontSize: "12pt" }} className="no-padding-bottom">
            <strong>INSIGHTS TAG CREATION</strong>
          </FullRow>
          <Row className="no-padding-top no-padding-bottom mb-20">
            <Col xs="4" sm="4" md="4" lg="4">
              <strong>Client Name</strong>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {clientName}
            </Col>
          </Row>
          <Row className="no-padding-top no-padding-bottom mb-20">
            <Col xs="4" sm="4" md="4" lg="4">
              <strong>Business Unit Name</strong>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {buName}
            </Col>
          </Row>
          <Row className="no-padding-top no-padding-bottom mb-20">
            <Col xs="4" sm="4" md="4" lg="4">
              <strong>Tag Deployment Type</strong>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8" className="no-padding-left">
              {isUndefined(this.props.id) ? (
                <Select
                  style={{ marginTop: "-10px" }}
                  value={this.state.tag_type}
                  name=""
                  clearable={false}
                  options={tagDevOptions}
                  searchable={false}
                  onChange={this.handleTagDevTypeChanged.bind(this)}
                />
              ) : (
                <span className="ml-10">
                  {this.state.tag_type === "Web"
                    ? "Web Property"
                    : "HTML Email"}
                </span>
              )}
            </Col>
          </Row>
          <Row
            className="no-padding-top no-padding-bottom"
            style={{
              display: this.state.tag_type === "Email" ? "block" : "none",
            }}
          >
            <Col xs="4" sm="4" md="4" lg="4" className="pt-5 no-padding-right">
              <strong>Email Campaign Name</strong>
              <span style={{ color: "red" }}>*</span>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {isUndefined(this.props.id) ? (
                <input
                  type="text"
                  value={this.props.campaign_name}
                  ref="inputCampaignNameRef"
                  style={inputStyle}
                  key={"campaign-name-input"}
                  onChange={(e) =>
                    this.handleCampaignNameChange(
                      e,
                      this.refs.inputCampaignNameRef.value,
                    )
                  }
                  placeholder="Please enter email campaign name"
                  maxLength="50"
                />
              ) : (
                <span>{this.props.campaign_name}</span>
              )}
            </Col>
          </Row>
          <Row
            className="no-padding-top no-padding-bottom mb-20"
            style={{
              display: this.state.tag_type === "Web" ? "block" : "none",
            }}
          >
            <Col xs="4" sm="4" md="4" lg="4" className="pt-5">
              <strong>Website Name</strong>
              <span style={{ color: "red" }}>*</span>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {isUndefined(this.props.id) ? (
                <input
                  type="text"
                  value={this.props.website_name}
                  ref="inputWebsiteNameRef"
                  style={inputStyle}
                  key={"website-name-input"}
                  onChange={(e) =>
                    this.handleWebsiteNameChange(
                      e,
                      this.refs.inputWebsiteNameRef.value,
                    )
                  }
                  placeholder="Please enter website name"
                  maxLength="50"
                />
              ) : (
                <span>{this.props.website_name}</span>
              )}
            </Col>
          </Row>
          <Row
            className="no-padding-top no-padding-bottom "
            style={{
              display: this.state.tag_type === "Web" ? "block" : "none",
            }}
          >
            <Col xs="4" sm="4" md="4" lg="4" className="pt-5">
              <strong>Website Domain</strong>
              <span style={{ color: "red" }}>*</span>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {isUndefined(this.props.id) ? (
                [
                  <input
                    type="text"
                    value={this.props.website_url}
                    ref="inputWebsiteURLRef"
                    style={inputStyle}
                    key={"url-input"}
                    onChange={(e) =>
                      this.handleWebsiteURLChange(
                        e,
                        this.refs.inputWebsiteURLRef.value,
                      )
                    }
                    placeholder="Please enter website Domain"
                    maxLength={200}
                  />,
                  <div
                    style={{
                      marginTop: "5px",
                      color: this.state.isValidDomain === true ? "#000" : "red",
                    }}
                  >
                    (Must be a fully qualified domain name)
                  </div>,
                ]
              ) : (
                <span>{this.props.website_url}</span>
              )}
            </Col>
          </Row>
          <FullRow
            className="no-padding-top no-padding-bottom no-margin-bottom"
            style={{
              display:
                this.state.tag_type === "Email" && this.props.roleId !== 1
                  ? "none"
                  : "block",
            }}
          >
            <hr style={{ borderColor: "#000" }} />
            <strong style={{ fontSize: "12pt" }}>CUSTOM VARIABLES</strong>
            <br />
            {showAddVarBtn ? (
              <button
                type="button"
                className="mt-10 btn btn-default legitRipple btn-aa-default"
                onClick={(e) => {
                  e.preventDefault();
                  this.showCustomVarsDialog();
                }}
              >
                ADD CUSTOM VARIABLES
              </button>
            ) : (
              <div>
                <table style={{ width: "100%", marginTop: "10px" }}>
                  <thead style={styles.tableHeaderStyle}>
                    <tr
                      style={{
                        height: "30px",
                        borderTop: "1px solid black",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <th style={{ ...styles.tableHeaderColumn, width: "40%" }}>
                        Reference Name
                      </th>
                      <th style={{ ...styles.tableHeaderColumn, width: "30%" }}>
                        Hash Case
                      </th>
                      <th style={{ ...styles.tableHeaderColumn, width: "30%" }}>
                        Variable Type
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.tag_variables.map((item, index) => {
                      return (
                        <tr key={"tag_vars_" + index}>
                          <td style={styles.tableTd}>{item}</td>
                          <td style={styles.tableTd}> &nbsp;</td>
                          <td style={styles.tableTd}>Page Reference</td>
                        </tr>
                      );
                    })}
                    {this.state.pass_variables.map((item, index) => {
                      return (
                        <tr key={"pass_vars_" + index}>
                          <td style={styles.tableTd}>{item}</td>
                          <td style={styles.tableTd}> &nbsp;</td>
                          <td style={styles.tableTd}>Pass Through</td>
                        </tr>
                      );
                    })}
                    {this.state.hash_format.map((item, index) => {
                      return (
                        <tr key={"pass_vars_" + index}>
                          <td style={styles.tableTd}>{item}</td>
                          <td style={styles.tableTd}>
                            {this.state.hash_case === "upper"
                              ? "Uppercase"
                              : "Lowercase"}
                          </td>
                          <td style={styles.tableTd}>Hashed Email</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <FullRow className="no-padding">
                  <button
                    type="button"
                    className="mt-20 btn btn-default legitRipple btn-aa-default pull-right"
                    onClick={(e) => {
                      e.preventDefault();
                      this.showCustomVarsDialog();
                    }}
                  >
                    Edit CUSTOM VARIABLES
                  </button>
                </FullRow>
                <FullRow
                  className="no-padding mt-10"
                  style={{
                    display: this.state.tag_type === "Web" ? "block" : "none",
                  }}
                >
                  <span>
                    We can deliver your custom variable tags in one of two ways.
                    Please select your
                    <br />
                    preferred method:
                  </span>
                  <br />
                  <input
                    type="radio"
                    name="varDeploy"
                    value="unique"
                    className="mt-20 mb-20"
                    onChange={(e) => {
                      this.handleOptionChange(e);
                    }}
                    checked={this.state.tag_vars_deploy === "unique"}
                  />
                  &nbsp;&nbsp;A unique tag for each page reference name you
                  entered.
                  <br />
                  <input
                    type="radio"
                    name="varDeploy"
                    value="dynamic"
                    onChange={(e) => {
                      this.handleOptionChange(e);
                    }}
                    checked={this.state.tag_vars_deploy === "dynamic"}
                  />
                  &nbsp;&nbsp;One tag where you can dynamically inject any of
                  the page reference names you entered when the tag is fired.
                  Note: This approach requires some additional programming on
                  your end.
                  <br />
                </FullRow>
              </div>
            )}
          </FullRow>
          <FullRow className="no-padding-top no-padding-bottom mb-20 text-right">
            <hr style={{ borderColor: "#000" }} />
            {isUndefined(this.props.id) ? (
              <button
                type="button"
                disabled={
                  this.state.tag_type === "Email"
                    ? isEmpty(this.props.campaign_name)
                    : isEmpty(this.props.website_name) ||
                      !this.state.isValidDomain
                }
                className="btn btn-default legitRipple btn-aa-default"
                onClick={(e) => {
                  this.clickGenerateTag(e);
                }}
              >
                GENERATE INSIGHTS TAG
              </button>
            ) : (
              [
                <Link
                  className="btn btn-default btn-aa-default legitRipple mr-20"
                  key="btn-cancel"
                  onClick={this.back2ListClick.bind(this)}
                  to="/settings/tags/list"
                >
                  CANCEL
                </Link>,
                <button
                  type="button"
                  key="btn-save-tag"
                  disabled={
                    this.state.tag_type === "Email"
                      ? isEmpty(this.props.campaign_name)
                      : isEmpty(this.props.website_name) ||
                        !this.state.isValidDomain
                  }
                  className="btn btn-default legitRipple btn-aa-default"
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleCloseConfirmDialog(true);
                  }}
                >
                  SAVE TAG
                </button>,
              ]
            )}
          </FullRow>
          <Dialog
            actions={[
              <Link
                className="btn btn-default btn-aa-default legitRipple mr-20"
                onClick={this.back2ListClick.bind(this)}
                to="/settings/tags/detail"
              >
                CLOSE
              </Link>,
            ]}
            contentStyle={{
              color: "rgba(0,0,0,1)",
              width: "400px",
              maxWidth: "none",
              textAlign: "center",
              fontWeight: "bold",
            }}
            modal={false}
            open={this.props.tag_updated_success === true}
            actionsContainerStyle={{
              textAlign: "center",
              paddingBottom: "20px",
            }}
          >
            <span
              style={{
                textAlign: "center",
                fontWeight: "600",
                color: "#000",
                fontSize: "11pt",
              }}
            >
              Your edits have been saved.
            </span>
          </Dialog>
          <Dialog
            actions={tagConfirmActions}
            contentStyle={{
              color: "rgba(0,0,0,1)",
              width: "600px",
              maxWidth: "none",
              textAlign: "center",
              fontWeight: "bold",
            }}
            modal={false}
            open={this.state.showTagConfirmDialog}
            actionsContainerStyle={{
              textAlign: "center",
              paddingBottom: "20px",
            }}
          >
            <span
              style={{
                textAlign: "center",
                fontWeight: "600",
                color: "#000",
                fontSize: "11pt",
              }}
            >
              Please confirm that your{" "}
              {this.state.tag_type === "Email"
                ? "Email Campaign Name is correct"
                : "Website Name and Website Domain are correct"}
              .
            </span>
            <span
              style={{
                display: this.props.tag_error_message ? "block" : "none",
                color: "red",
                fontSize: "9pt",
                marginTop: "10px",
              }}
            >
              {this.props.tag_error_message}
            </span>
          </Dialog>
          <Dialog
            actions={custVarsActions}
            title="CUSTOM VARIABLE SETUP"
            contentStyle={{
              paddingBottom: "0px",
              fontSize: "13px",
              color: "#000000",
              width: "510px",
              paddingBotom: "0px",
              maxWidth: "none",
              maxHeight: "none",
            }}
            bodyStyle={{
              paddingTop: "20px",
              fontSize: "13px",
              color: "#000",
              paddingBottom: "0px",
            }}
            modal={false}
            autoScrollBodyContent={true}
            open={this.state.showCustomVarDialog}
            titleStyle={{
              fontSize: "16px",
              fontWeight: "bold",
              paddingBottom: "10px",
              paddingTop: "10px",
            }}
            actionsContainerStyle={{
              textAlign: "center",
              paddingBottom: "40px",
              paddingLeft: "20px",
              paddingRight: "20px",
            }}
          >
            {this.state.tag_type !== "Email" && (
              <CustomTagVariables
                variables={this.state.tag_variables}
                varChanged={this.tagVarChanged.bind(this)}
                addVariable={this.addTagVariable.bind(this)}
                removeVariable={this.removeTagVariable.bind(this)}
                varType="page"
              />
            )}
            {isSysAdmin && (
              <CustomTagVariables
                variables={this.state.pass_variables}
                varChanged={this.passThroughChanged.bind(this)}
                addVariable={this.addPassThrough.bind(this)}
                removeVariable={this.removePassThrough.bind(this)}
                varType="passthrough"
              />
            )}
            {isSysAdmin && (
              <HashedEmailVariables
                hashCase={this.state.hash_case}
                hashFormat={this.state.hash_format}
                handleHashFormatChanged={this.handleHashFormatChanged.bind(
                  this,
                )}
                handleHashCaseChanged={this.handleHashCaseChanged.bind(this)}
              />
            )}
          </Dialog>
        </div>
      </div>
    );
  }
}

export default TagCreation;



// WEBPACK FOOTER //
// ./src/components/Insights/tags/TagCreation.jsx